/* dcl-sock-b2g1.js  (rev 3, 2026-10-30: collection banner on ink with red headline, red was hard on the eyes)
 * Sock Guy buy 2, get 1 free. Customer-facing messaging only; the discount itself is the
 * Shopify automatic discount "Sock Guy - Buy 2, Get 1 Free" (customer buys 2 from the
 * Sock Guy collection, gets 1 from the same collection at 100% off, no per-order cap,
 * combines with shipping discounts only). Shopify discounts the lowest-priced qualifying pair.
 *
 * Loaded from layout/theme.liquid only when shop metafield dcl.sock_b2g1_enabled is true.
 * To end the promotion: deactivate the discount AND set that metafield to false. If the two
 * drift apart, the site promises a free pair the cart will not give.
 *
 * Three surfaces:
 *   PDP    Sock Guy product pages: offer line above the add-to-cart form. Last pairs styles
 *          (tag sock-last-pairs) get a second line saying the style is leaving the lineup.
 *   BANNER /collections/sock-guy: offer strip above the product grid.
 *   CART   Cart page and drawer, whenever Sock Guy is in the cart: progress toward the free
 *          pair, computed from Sock Guy quantity (free pairs = floor(qty / 3)).
 */
(function () {
  'use strict';
  if (window.__dclSockB2g1) return;
  window.__dclSockB2g1 = true;
  var CFG = window.DCL_SOCK_B2G1 || {};
  var VENDOR = 'Sock Guy';
  var RED = '#e42e0f';
  var CART_ID = 'dcl-sock-cart-note';
  var pending = false;
  var lastN = 0;

  function icon(size) {
    return '<svg viewBox="0 0 24 24" width="' + size + '" height="' + size + '" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect>' +
      '<line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>' +
      '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>';
  }

  function styles() {
    if (document.getElementById('dcl-sock-css')) return;
    var s = document.createElement('style');
    s.id = 'dcl-sock-css';
    s.textContent = [
      '.dcl-sock-pdp{display:flex;gap:10px;align-items:flex-start;margin:0 0 1rem;padding:.8rem .95rem;',
      'background:#1a1a1a!important;color:#fff!important;border-radius:10px;font-size:.9375rem;line-height:1.45}',
      '.dcl-sock-pdp svg{flex:0 0 18px;margin-top:2px}',
      '.dcl-sock-pdp strong{color:' + RED + '!important;font-weight:700}',
      '.dcl-sock-pdp .dcl-sock-sub{display:block;opacity:.85;font-size:.875rem;margin-top:2px}',
      '.dcl-sock-last{margin:-.4rem 0 1rem;font-size:.875rem;line-height:1.45}',
      '.dcl-sock-last b{font-weight:700}',
      '.dcl-sock-banner{background:#1a1a1a!important;color:#fff!important;margin:0 0 1.75rem;border-bottom:4px solid #e42e0f}',
      '.dcl-sock-banner__in{display:flex;align-items:center;justify-content:space-between;gap:28px;padding:22px 0}',
      '.dcl-sock-banner__lead{display:flex;align-items:center;gap:18px;min-width:0}',
      '.dcl-sock-banner__mark{display:inline-flex;align-items:center;justify-content:center;width:58px;height:58px;',
      'border-radius:50%;background:#e42e0f!important;color:#fff!important;flex:0 0 58px}',
      '.dcl-sock-banner__eyebrow{display:block;font-size:12px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;opacity:.92;margin:0 0 4px}',
      '.dcl-sock-banner__h{margin:0;font-family:var(--font-heading-family);font-style:italic;font-weight:800;text-transform:uppercase;',
      'letter-spacing:-0.01em;line-height:1;font-size:clamp(28px,3.6vw,46px);color:#e42e0f!important}',
      '.dcl-sock-banner__w{color:#fff!important}',
      '.dcl-sock-banner__pts{list-style:none;margin:0;padding:0 0 0 28px;border-left:1px solid rgba(255,255,255,.3);display:grid;gap:7px;flex:0 0 auto}',
      '.dcl-sock-banner__pts li{display:flex;align-items:center;gap:9px;font-size:15px;font-weight:600;line-height:1.3;color:#fff!important}',
      '.dcl-sock-banner__pts svg{flex:0 0 16px;color:#e42e0f}',
      '@media (max-width:899px){.dcl-sock-banner__in{flex-direction:column;align-items:flex-start;gap:16px;padding:18px 0}',
      '.dcl-sock-banner__pts{border-left:0;padding:14px 0 0;border-top:1px solid rgba(255,255,255,.3);width:100%}',
      '.dcl-sock-banner__mark{width:46px;height:46px;flex-basis:46px}.dcl-sock-banner__pts li{font-size:14px}}',
      '#' + CART_ID + '{display:block;text-align:center;padding:.875rem 1rem;background:#1a1a1a!important;',
      'color:#fff!important;border-radius:12px;margin:0 0 .75rem}',
      '#' + CART_ID + ' .dcl-sk-row{display:flex;align-items:center;justify-content:center;gap:.5rem;flex-wrap:wrap}',
      '#' + CART_ID + ' .dcl-sk-mark{display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;',
      'border-radius:50%;background:#fff!important;color:#1a1a1a!important;flex:0 0 26px}',
      '#' + CART_ID + ' .dcl-sk-copy{font-weight:700;font-size:inherit;line-height:1.35;color:#fff!important}',
      '#' + CART_ID + ' .dcl-sk-em{color:' + RED + '!important}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- Product page ---------- */
  function pdp() {
    if (!CFG.pdp || document.querySelector('.dcl-sock-pdp')) return;
    var target = document.querySelector('#MainContent form[action*="/cart/add"]') || document.querySelector('#MainContent .product-form');
    if (!target || !target.parentNode) return;
    var note = document.createElement('div');
    note.className = 'dcl-sock-pdp';
    note.setAttribute('role', 'note');
    note.innerHTML = icon(18) + '<span><strong>Buy 2, get 1 free</strong> on all Sock Guy socks.' +
      '<span class="dcl-sock-sub">Mix any styles and sizes. The lowest-priced pair is free, and it comes off automatically in your cart.</span></span>';
    target.parentNode.insertBefore(note, target);
    if (CFG.last) {
      var last = document.createElement('p');
      last.className = 'dcl-sock-last';
      last.innerHTML = '<b>Last pairs.</b> This style is leaving our Sock Guy lineup, so once these are gone, they are gone.';
      target.parentNode.insertBefore(last, target);
    }
  }

  /* ---------- Collection banner ---------- */
  function check() {
    return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  }
  function banner() {
    if (!CFG.collection || document.querySelector('.dcl-sock-banner')) return;
    /* Sits directly under the collection hero so it reads as part of the page header.
       Falls back to just above the product grid if the hero is missing. */
    var hero = document.querySelector('.dcl-ch');
    var after = hero && (hero.closest('.shopify-section') || hero);
    var grid = document.getElementById('ProductGridWrapper');
    var before = grid && grid.closest('.collection');
    if (!after && !before) return;
    var b = document.createElement('section');
    b.className = 'dcl-sock-banner';
    b.setAttribute('aria-label', 'Buy 2, get 1 free on all Sock Guy socks');
    b.innerHTML = '<div class="page-width"><div class="dcl-sock-banner__in">' +
      '<div class="dcl-sock-banner__lead"><span class="dcl-sock-banner__mark">' + icon(28) + '</span>' +
      '<div><span class="dcl-sock-banner__eyebrow">All Sock Guy socks</span>' +
      '<p class="dcl-sock-banner__h"><span class="dcl-sock-banner__w">Buy 2,</span> get 1 free!</p></div></div>' +
      '<ul class="dcl-sock-banner__pts">' +
      '<li>' + check() + 'Mix any styles and sizes</li>' +
      '<li>' + check() + 'The lowest-priced pair is free</li>' +
      '<li>' + check() + 'Comes off automatically in your cart</li>' +
      '<li>' + check() + 'Styles marked Last pairs are leaving our lineup</li>' +
      '</ul></div></div>';
    if (after && after.parentNode) after.parentNode.insertBefore(b, after.nextSibling);
    else before.parentNode.insertBefore(b, before);
  }

  /* ---------- Cart ---------- */
  function sockQty(cart) {
    var n = 0, items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i] && items[i].vendor === VENDOR) n += items[i].quantity || 0;
    return n;
  }
  function plural(n, one, many) { return n === 1 ? one : many; }
  function copyFor(n) {
    var free = Math.floor(n / 3), rem = n % 3;
    var em = function (t) { return '<span class="dcl-sk-em">' + t + '</span>'; };
    if (free === 0 && rem === 1) return 'Buy 2, get 1 free on Sock Guy socks. Add ' + em('2 more pairs') + ' and the lowest-priced one is free.';
    if (free === 0 && rem === 2) return 'Add ' + em('1 more pair') + ' of Sock Guy socks and the lowest-priced pair is free.';
    var got = em(free + ' free ' + plural(free, 'pair', 'pairs')) + ' of Sock Guy socks in your cart.';
    if (rem === 2) return got + ' Add 1 more pair for another free one.';
    if (rem === 1) return got + ' Add 2 more pairs for another free one.';
    return got;
  }
  function mounts() {
    var found = [], sels = ['.cart__footer-wrapper', '.cart-drawer__footer'];
    for (var i = 0; i < sels.length; i++) { var ns = document.querySelectorAll(sels[i]); for (var k = 0; k < ns.length; k++) found.push(ns[k]); }
    if (!found.length) { var fb = document.querySelectorAll('.drawer__footer-body'); for (var f = 0; f < fb.length; f++) found.push(fb[f]); }
    return found;
  }
  function renderCart(n) {
    var stale = document.querySelectorAll('#' + CART_ID);
    for (var i = 0; i < stale.length; i++) stale[i].parentNode && stale[i].parentNode.removeChild(stale[i]);
    if (n <= 0) return;
    var hosts = mounts();
    for (var h = 0; h < hosts.length; h++) {
      if (hosts[h].querySelector('#' + CART_ID)) continue;
      var w = document.createElement('div');
      w.id = CART_ID;
      w.innerHTML = '<div class="dcl-sk-row"><span class="dcl-sk-mark">' + icon(16) + '</span><span class="dcl-sk-copy">' + copyFor(n) + '</span></div>';
      hosts[h].insertBefore(w, hosts[h].firstChild);
    }
  }
  function refresh() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { pending = false; if (cart) { lastN = sockQty(cart); renderCart(lastN); } })
      .catch(function () { pending = false; });
  }
  function watch() {
    if (!window.MutationObserver) return;
    var seen = false;
    new MutationObserver(function () {
      var open = !!document.querySelector('.cart-drawer__footer, .cart__footer-wrapper');
      if (open && !seen) refresh();
      seen = open;
      if (open && lastN > 0 && !document.querySelector('#' + CART_ID)) setTimeout(refresh, 300);
      pdp(); banner();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart], quantity-input, .quantity__button, cart-remove-button') : null;
      if (el) setTimeout(refresh, 800);
    }, true);
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.cart-item, cart-drawer, cart-items')) setTimeout(refresh, 800); }, true);
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:updated', refresh);
  }

  function start() { styles(); pdp(); banner(); refresh(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
